.avatar {
  inline-size: 24px;
  block-size: 24px;
  flex: none;
  display: grid;
  place-items: center;
  background: var(--surface-strong);
  color: var(--text-muted);
  font-size: 11px;
  font-weight: var(--font-weight-semibold);
}

/* The decorative initials (Avatar.tsx): generated content, so they are not text a label must repeat. */
.avatar[data-initials]::before {
  content: attr(data-initials);
}

.circle {
  border-radius: 50%;
}

.square {
  border-radius: var(--radius-control);
}

/* Mockup v3 P1: the person's own picture fills the circle. */
.picture {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
}
